import { args } from '../../common/args';
import { defineCapability } from './define-capability';

export const __NOOP_MOCK_CAP = defineCapability({
  name: '__NOOP_MOCK_CAP' as const,
  args: {
    id: args.string(),
  },
});
